import { useEffect } from 'react';
import { useCurrentClientManager } from '@cko/dashboard-shared';
import { HeapAPI, HeapEventPropertyKeys } from './HeapAPI';

export const useUpdateHeapClientProperties = (isReady: boolean, api: HeapAPI) => {
  const { client, entity, segment, subEntity } = useCurrentClientManager();

  useEffect(() => {
    if (isReady) {
      api.addEventProperties({
        [HeapEventPropertyKeys.CLIENT_ID]: client.id,
        [HeapEventPropertyKeys.CLIENT_NAME]: client.name,
      });
    }
  }, [client, isReady, api]);

  useEffect(() => {
    if (isReady) {
      if (entity) {
        api.addEventProperties({
          [HeapEventPropertyKeys.ENTITY_ID]: entity.id,
          [HeapEventPropertyKeys.ENTITY_NAME]: entity.name,
        });
      } else {
        api.removeEventProperty(HeapEventPropertyKeys.ENTITY_ID);
        api.removeEventProperty(HeapEventPropertyKeys.ENTITY_NAME);
      }
    }
  }, [entity, isReady, api]);

  useEffect(() => {
    if (isReady) {
      if (segment) {
        api.addEventProperties({
          [HeapEventPropertyKeys.SEGMENT_ID]: segment.id,
          [HeapEventPropertyKeys.SEGMENT_NAME]: segment.name,
        });
      } else {
        api.removeEventProperty(HeapEventPropertyKeys.SEGMENT_ID);
        api.removeEventProperty(HeapEventPropertyKeys.SEGMENT_NAME);
      }
    }
  }, [segment, isReady, api]);

  useEffect(() => {
    if (isReady) {
      if (subEntity) {
        api.addEventProperties({
          [HeapEventPropertyKeys.SUB_ENTITY_ID]: subEntity.id,
          [HeapEventPropertyKeys.SUB_ENTITY_NAME]: subEntity.name,
        });
      } else {
        api.removeEventProperty(HeapEventPropertyKeys.SUB_ENTITY_ID);
        api.removeEventProperty(HeapEventPropertyKeys.SUB_ENTITY_NAME);
      }
    }
  }, [subEntity, isReady, api]);
};
